import { create } from 'apisauce';

import { cdnCacheApiKey, cdnCacheApiUrl } from '@config/api';

const api = create({
  baseURL: cdnCacheApiUrl,
  headers: { accept: '*/*', ApiKey: cdnCacheApiKey },
});

export const deleteMediaCache = (mediaId: string) => {
  if (cdnCacheApiUrl) return api.delete(`cdn/v1.0/cache/content/${mediaId}`);
  else
    return new Promise(resolve => {
      // TODO: Tmp solution until CDN cache purge is supported in DEV/Prod
      console.error("Can't wipe CDN cache.");
      resolve('');
    });
};
